<script lang="ts">
    import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
    import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
    import type { Signal } from '@preact/signals-react';
    import { legsQueryOptionsRegistry } from './legsQueryOptionsRegistry';
    import type { LegsQueryOptionsSignal } from './types';

    interface Props {
        /** The side value to display (e.g., "BUY", "SELL", "MULTI") */
        sideValue: Signal<string>;
        /** Whether this is a multi-leg order that should show the info icon */
        isMultiLeg: Signal<boolean>;
        /** Query options for fetching legs data, registered in WeakMap for hover card lookup */
        queryOptions: LegsQueryOptionsSignal;
    }

    let { sideValue, isMultiLeg, queryOptions }: Props = $props();

    /** Reference to the icon element, used as the key for the WeakMap registry */
    let iconElement: HTMLSpanElement | undefined = $state();

    // Register the query options signal in the WeakMap when the icon element is mounted
    // WeakMap automatically cleans up when the element is removed from the DOM
    $effect(() => {
        if (iconElement) {
            legsQueryOptionsRegistry.set(iconElement, queryOptions);
        }
    });
</script>

<span class="flex items-center">
    <span>{$sideValue}</span>
    {#if $isMultiLeg}
        <span
            bind:this={iconElement}
            class="legs-icon-hover ml-1 cursor-pointer text-steel-500 transition-colors hover:text-blue-500"
            role="button"
            tabindex="0"
            aria-label="View order legs"
        >
            <span aria-hidden="true"><FontAwesomeIcon icon={faCircleInfo} class="text-xs" /></span>
        </span>
    {/if}
</span>
